export const MAX_PIXEL_RATIO = 2;
